export default __webpack_public_path__ + "static/media/blog-fire-pit-003.0f754099.jpg";